<template>
  <div>
    <div
      class="spinner-grow"
      role="status"
      v-if="allLoading === true || loading === true"
    ></div>

    <div class="dropdown" style="margin-bottom: 20px">
      <div class="dropdown-trigger" @click="toggleDropdown">
        {{ selectedType ? selectedType.label : "Select Terminal Type" }}
        <span class="arrow" :class="{ open: isOpen }">▼</span>
      </div>

      <ul v-if="isOpen" class="menu">
        <li
          v-for="option in transactionTypeOptions"
          :key="option.key"
          @click="selectOption(option)"
          :class="{
            active: selectedType && selectedType.key === option.key,
          }"
        >
          {{ option.label }}
        </li>
      </ul>
    </div>

    <div
      v-if="
        (selectedType && selectedType.key === 'ALL') ||
        selectedType.key === 'WITHDRAWAL' ||
        selectedType.key === 'TRANSFER' ||
        selectedType.key === 'AIRTIME' ||
        selectedType.key === 'DATA' ||
        selectedType.key === 'ELECTRICITY' ||
        selectedType.key === 'CABLE'
      "
      class="card-stats-container"
    >
      <SummaryCard
        :logo="require('@/assets/img/people.png')"
        title="Total Transactions (Vol)"
        :number="this.totalTransactions.count"
      />

      <SummaryCard
        :logo="require('@/assets/img/configured.png')"
        title="Successful Transactions (Vol)"
        :number="this.successfulTransactions.count"
        :percentage="getPercentageVol(this.successfulTransactions.count)"
      />

      <SummaryCard
        :logo="require('@/assets/img/notconfigured.png')"
        title="Failed Transactions (Vol)"
        :number="this.failedTransactions.count"
        :percentage="getPercentageVol(this.failedTransactions.count)"
      />

      <SummaryCard
        :logo="require('@/assets/img/T3.png')"
        title="Pending Transactions (Vol)"
        :number="this.pendingTransactions.count"
        :percentage="getPercentageVol(this.pendingTransactions.count)"
      />

      <SummaryCard
        :logo="require('@/assets/img/MPOS.png')"
        title="Reversed Transactions (Vol)"
        :number="this.reversedTransactions.count"
        :percentage="getPercentageVol(this.reversedTransactions.count)"
      />

      <SummaryCard
        :logo="require('@/assets/img/people.png')"
        title="Total Transactions (Value)"
        :number="this.totalTransactions.value"
        :naira="true"
      />

      <SummaryCard
        :logo="require('@/assets/img/configured.png')"
        title="Successful Transactions (Val)"
        :number="this.successfulTransactions.value"
        :percentage="getPercentageValue(this.successfulTransactions.value)"
        :naira="true"
      />

      <SummaryCard
        :logo="require('@/assets/img/notconfigured.png')"
        title="Failed Transactions (Val)"
        :number="this.failedTransactions.value"
        :percentage="getPercentageValue(this.failedTransactions.value)"
        :naira="true"
      />

      <SummaryCard
        :logo="require('@/assets/img/T3.png')"
        title="Pending Transactions (Val)"
        :number="this.pendingTransactions.value"
        :percentage="getPercentageValue(this.pendingTransactions.value)"
        :naira="true"
      />

      <SummaryCard
        :logo="require('@/assets/img/MPOS.png')"
        title="Reversed Transactions (Val)"
        :number="this.reversedTransactions.value"
        :percentage="getPercentageValue(this.reversedTransactions.value)"
        :naira="true"
      />
    </div>

    <div
      v-if="selectedType && selectedType.key === 'PAY_WITH_TRANSFER'"
      style="
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
        margin-bottom: 24px;
      "
    >
      <SummaryCard
        :logo="require('@/assets/img/people.png')"
        title="Total Transactions (Vol)"
        :number="this.totalTransactions.count"
      />

      <SummaryCard
        :logo="require('@/assets/img/configured.png')"
        title="Successful Transactions (Vol)"
        :number="this.successfulTransactions.count"
        :percentage="getPercentageVol(this.successfulTransactions.count)"
      />

      <SummaryCard
        :logo="require('@/assets/img/people.png')"
        title="Failed Transactions (Vol)"
        :number="failedTransactions.count"
        :percentage="getPercentageVol(failedTransactions.count)"
      />

      <SummaryCard
        :logo="require('@/assets/img/people.png')"
        title="Total Transactions (Value)"
        :naira="true"
        :number="this.totalTransactions.value"
      />

      <SummaryCard
        :logo="require('@/assets/img/configured.png')"
        title="Successful Transactions (Val)"
        :naira="true"
        :number="this.successfulTransactions.value"
        :percentage="getPercentageValue(this.successfulTransactions.value)"
      />
      <SummaryCard
        :logo="require('@/assets/img/people.png')"
        title="Failed Transactions (Val)"
        :naira="true"
        :number="failedTransactions.value"
        :percentage="getPercentageValue(failedTransactions.value)"
      />
    </div>

    <div style="display: flex; gap: 20px">
      <div class="barChart pie-containers">
        <div class="sort-by">
          <div class="dropdown">
            <div class="dropdown-trigger" @click="toggleBarDropdown">
              {{
                selectedBarType ? selectedBarType.label : "Select Terminal Type"
              }}
              <span class="arrow" :class="{ open: isBarOpen }">▼</span>
            </div>

            <ul v-if="isBarOpen" class="menu">
              <li
                v-for="option in barChartOptions"
                :key="option.value"
                @click="selectOptionBarType(option)"
                :class="{
                  active:
                    selectedBarType && selectedBarType.value === option.value,
                }"
              >
                {{ option.label }}
              </li>
            </ul>
          </div>

          <div class="col-4 m-0">
            <select
              class="form-control"
              v-model="sortOrder"
              @change="buildChart"
            >
              <option value="asc">Sort By: Ascending</option>
              <option value="desc">Sort By: Descending</option>
            </select>
          </div>

          <div class="metric-tabs m-0">
            <div
              v-for="option in metricOptions"
              :key="option.key"
              class="metric-tab"
              :class="{ active: selectedChartMetric === option.key }"
              @click="selectChartMetric(option.key)"
            >
              {{ option.label }}
            </div>
          </div>
        </div>
        <div class="chart-wrapper" style="overflow-y: auto; height: 400px">
          <div ref="barChart" class="ct-chart ct-golden-section"></div>
        </div>
      </div>

      <div
        class="pie-containers"
        v-if="
          (selectedType && selectedType.key === 'ALL') ||
          selectedType.key === 'WITHDRAWAL' ||
          selectedType.key === 'TRANSFER' ||
          selectedType.key === 'AIRTIME' ||
          selectedType.key === 'DATA' ||
          selectedType.key === 'ELECTRICITY' ||
          selectedType.key === 'CABLE'
        "
      >
        <div class="sort-by" style="align-items: start">
          <div
            class="dropdown"
            style="padding-left: 0px; padding-right: 0px"
            v-if="
              (selectedType && selectedType.key === 'ALL') ||
              selectedType.key === 'WITHDRAWAL' ||
              selectedType.key === 'AIRTIME' ||
              selectedType.key === 'DATA' ||
              selectedType.key === 'ELECTRICITY' ||
              selectedType.key === 'CABLE'
            "
          >
            <div class="dropdown-trigger" @click="togglePieDropdown">
              {{
                selectedPieType ? selectedPieType.label : "Select Terminal Type"
              }}
              <span
                class="arrow"
                :class="{ open: isPieOpen }"
                v-if="pieChartOptions.length > 1"
                >▼</span
              >
            </div>

            <ul v-if="isPieOpen" class="menu">
              <li
                v-for="option in pieChartOptions"
                :key="option.value"
                @click="selectOptionPieType(option)"
                :class="{
                  active:
                    selectedPieType && selectedPieType.value === option.value,
                }"
              >
                {{ option.label }}
              </li>
            </ul>
            <p>Breakdown of deployed terminal devices</p>
          </div>

          <div class="metric-tabs">
            <div
              v-for="option in metricOptions"
              :key="option.key"
              class="metric-tab"
              :class="{ active: selectedMetric === option.key }"
              @click="selectMetric(option.key)"
            >
              {{ option.label }}
            </div>
          </div>
        </div>

        <div style="display: flex; align-items: center; gap: 20px">
          <div class="pie-wrapper">
            <div ref="pieChart" class="ct-chart ct-major-tenth"></div>
          </div>

          <div class="custom-legend">
            <div
              v-for="(label, index) in pieChartData.labels || []"
              :key="index"
              style="
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 8px;
              "
            >
              <!-- color circle -->
              <span
                class="circle"
                style="
                  display: block;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                "
                :style="{
                  backgroundColor:
                    pieChartData.datasets &&
                    pieChartData.datasets[0] &&
                    pieChartData.datasets[0].backgroundColor
                      ? pieChartData.datasets[0].backgroundColor[index]
                      : '#ccc',
                }"
              ></span>

              <!-- legend text -->
              <span
                class="legend-text"
                style="display: flex; align-items: center; gap: 8px"
              >
                <!-- label -->
                <span>{{ label || "Unknown" }}</span>

                <!-- percentage -->
                <!-- <span style="color: #615e83; font-size: 14px">
                  {{
                    pieChartData.datasets &&
                    pieChartData.datasets[0] &&
                    pieChartData.datasets[0].data
                      ? (pieChartData.datasets[0].data[index] / 100).toFixed(2)
                      : 0
                  }}%
                </span> -->

                <span style="color: #615e83; font-size: 14px">
                  {{
                    pieChartData.datasets && pieChartData.datasets[0].data
                      ? (
                          (pieChartData.datasets[0].data[index] /
                            pieChartData.datasets[0].data.reduce(
                              (sum, value) => sum + value,
                              0,
                            )) *
                          100
                        ).toFixed(2)
                      : 0
                  }}%
                </span>

                <!-- count -->
                <span style="color: #23242f; font-size: 14px">
                  ({{ pieChartData.counts ? pieChartData.counts[index] : 0 }})
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="search-container">
      <div class="search-items">
        <div class="col-auto p-0 m-0" style="">
          <select
            class="form-control"
            v-model="selectedValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select a search parameter</option>
            <option value="agentName">Agent Name</option>
            <option value="agentCategory">Agent Category</option>
            <option
              v-if="
                selectedType.key === 'AIRTIME' ||
                selectedType.key === 'DATA' ||
                selectedType.key === 'ELECTRICITY'
              "
              value="product"
            >
              Product
              <span
                v-if="
                  selectedType.key === 'AIRTIME' || selectedType.key === 'DATA'
                "
                >(Network)</span
              >
              <span v-if="selectedType.key === 'ELECTRICITY'">(Discos)</span>
            </option>
            <option
              value="terminalId"
              v-if="
                (selectedType && selectedType.key === 'ALL') ||
                selectedType.key === 'WITHDRAWAL' ||
                selectedType.key === 'TRANSFER' ||
                selectedType.key === 'DATA'
              "
            >
              Terminal ID
            </option>
            <option
              value="merchantId"
              v-if="
                (selectedType && selectedType.key === 'ALL') ||
                selectedType.key === 'WITHDRAWAL' ||
                selectedType.key === 'TRANSFER' ||
                selectedType.key === 'DATA'
              "
            >
              Merchant ID
            </option>
            <option v-if="selectedType.key === 'TRANSFER'" value="reference">
              Reference
            </option>
            <option
              v-if="
                selectedType.key === 'AIRTIME' ||
                selectedType.key === 'ELECTRICITY' ||
                selectedType.key === 'CABLE'
              "
              value="reference"
            >
              Transaction ID
            </option>
            <option
              v-if="
                selectedType.key === 'PAY_WITH_TRANSFER' ||
                selectedType.key === 'AIRTIME' ||
                selectedType.key === 'DATA' ||
                selectedType.key === 'ELECTRICITY' ||
                selectedType.key === 'CABLE'
              "
              value="walletId"
            >
              Wallet ID
            </option>
            <option
              v-if="
                selectedType.key === 'PAY_WITH_TRANSFER' ||
                selectedType.key === 'AIRTIME'
              "
              value="provider"
            >
              Provider
            </option>

            <option
              v-if="selectedType.key === 'DATA' || selectedType.key === 'CABLE'"
              value="status"
            >
              Provider Status
            </option>
          </select>
        </div>
        <div class="col-auto p-0 m-0" v-if="selectedValue">
          <label for="inlineFormInput">Enter Value</label>
          <div class="input-group">
            <input
              id="inlineFormInputGroup"
              class="form-control"
              v-model="searchValues[selectedValue]"
              :placeholder="`Enter ${selectedValue.replace(/Id/g, ' Id')}`"
              type="text"
            />
          </div>
        </div>

        <div class="col-auto p-0 m-0">
          <label>Start Date</label>
          <div class="input-group">
            <input
              type="date"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Start Date"
              v-model="startDate"
            />
          </div>
        </div>

        <div class="col-auto p-0 m-0">
          <label>End Date</label>
          <div class="input-group">
            <input
              type="date"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="End Date"
              v-model="endDate"
            />
          </div>
        </div>
      </div>

      <div class="action_btns">
        <button type="submit" class="btn btn-blue" @click="refresh('filter')">
          FILTER
        </button>

        <button class="btn btn-blue" @click="refresh('refresh')">
          REFRESH
        </button>

        <button class="btn btn-blue" @click="refresh('download')">
          EXPORT CSV
        </button>
      </div>
    </div>

    <div class="col-12 p-0 m-0">
      <card class="card-plain">
        <div class="table-full-width table-responsive table-container">
          <table class="table">
            <thead class="tms-dark">
              <tr>
                <th
                  v-for="col in activeSchema"
                  :key="col.label"
                  style="text-align: center"
                >
                  {{ col.label }}
                </th>
              </tr>
            </thead>

            <tbody v-if="tableLoading === true">
              <tr>
                <td colspan="100%" class="text-center">
                  <div>
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody
              v-else-if="analyticsTransactions.length === 0 && !tableLoading"
            >
              <tr>
                <td colspan="100%" class="text-center">
                  <div class="">
                    <div class="alert-icon">
                      <i class="fa fa-info-circle"></i>
                    </div>
                    <span>No Transactions Found</span>
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody v-else>
              <tr
                v-for="(row, index) in analyticsTransactions"
                :key="row._id || index"
              >
                <td
                  v-for="col in activeSchema"
                  :key="col.label"
                  style="text-align: center"
                >
                  <!-- Index column -->
                  <span v-if="col.type === 'index'">
                    {{ limit * (page - 1) + (index + 1) }}
                  </span>

                  <!-- Formatter column -->
                  <span v-else-if="col.formatter">
                    {{ col.formatter(row) }}
                  </span>

                  <!-- Plain field column -->
                  <span v-else>
                    {{ safeValue(row, col.field) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>

    <div
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <div class="paginate-btns" style="display: flex; align-items: center">
        <div class="p-2">
          <button
            type="submit"
            class="btn btn-primary"
            @click="refresh('previous')"
          >
            Prev
          </button>
        </div>
        <div>Page {{ currentPage }} of {{ totalPages }}</div>
        <div class="p-2" v-if="hasNextPage === true">
          <button
            type="submit"
            class="btn btn-primary"
            @click="refresh('next')"
          >
            Next
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-center">
        <div class="p-2">
          <div class="btn">Total Records: {{ totalDocs }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../store/axios";
import { convertArrayToCSV } from "convert-array-to-csv";
import fileDownload from "js-file-download";
import SummaryCard from "../components/Cards/SummaryCard.vue";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import Chartist from "chartist";
import "chartist/dist/chartist.min.css";
import { get } from "jquery";

export default {
  components: {
    SummaryCard,
  },

  data() {
    return {
      loading: false,
      tableLoading: false,
      allLoading: false,
      selectedType: { label: "Withdrawal Transactions", key: "WITHDRAWAL" },
      transactionTypeOptions: [
        { label: "ALL Transactions", key: "ALL" },
        // { label: "Purchase Transactions", key: "PURCHASE" },
        { label: "Withdrawal Transactions", key: "WITHDRAWAL" },
        {
          label: "Pay With Transfer (Incoming) Transactions",
          key: "PAY_WITH_TRANSFER",
        },
        {
          label: "Transfer (Outgoing) Transactions",
          key: "TRANSFER",
        },
        {
          label: "Bill Payments (Airtime Purchase) Transactions",
          key: "AIRTIME",
        },
        {
          label: "Bill Payments (Data Purchase) Transactions",
          key: "DATA",
        },
        {
          label: "Bill Payments (Electricity Purchase) Transactions",
          key: "ELECTRICITY",
        },
        {
          label: "Bill Payments (Cable TV Subscription) Transactions",
          key: "CABLE",
        },
      ],
      isOpen: false,
      failedTransactions: {},
      pendingTransactions: {},
      reversedTransactions: {},
      successfulTransactions: {},
      totalTransactions: {},
      page: 1,
      currentPage: 1,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      limit: 20,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: null,
      analyticsTransactions: [],
      totalDocs: 0,
      selectedValue: "",
      searchValues: {
        agentName: "",
        agentCategory: "",
        terminalId: "",
        merchantId: "",
        reference: "",
      },
      groupByCustomerCategory: {},
      groupByCustomerName: {},
      groupByProduct: {},
      groupBySalesOfficer: {},
      groupByTerminalId: {},
      groupByWalletId: {},
      sortOrder: "desc",
      selectedBarType: {
        label: "Agent Category",
        value: "customerCategory",
        key: "groupByCustomerCategory",
      },
      barChartOptions: [
        // {
        //   label: "Transaction Type",
        //   value: "transactionType",
        //   key: "groupByProduct",
        // },
        {
          label: "Agent Category",
          value: "customerCategory",
          key: "groupByCustomerCategory",
        },
        {
          label: "Agent Name",
          value: "customerName",
          key: "groupByCustomerName",
        },
        {
          label: "Sales Officer",
          value: "salesOfficer",
          key: "groupBySalesOfficer",
        },
        // {
        //   label: "Terminal ID",
        //   value: "terminalId",
        //   key: "groupByTerminalId",
        // },
        // {
        //   label: "Wallet ID",
        //   value: "walletId",
        //   key: "groupByWalletId",
        // },
      ],
      terminalType: [],
      provider: [],
      selectedPieType: {
        label: "Terminal Type",
        value: "terminalType",
      },

      metricOptions: [
        { label: "Volume", key: "volume" },
        { label: "Value", key: "value" },
      ],
      selectedMetric: "volume",
      selectedChartMetric: "volume",
      isBarOpen: false,
      isPieOpen: false,
      allMerchants: [],
      allSalesOfficers: [],
      allInstitutions: [],
      tableSchemas: {
        WITHDRAWAL: [
          { label: "S/N", type: "index" },
          { label: "Transaction Type", field: "requestType" },
          { label: "Agent Name", field: "customerName" },
          {
            label: "Agent Category",
            formatter: (row) =>
              this.getMerchantName(row.customerCategory) || "N/A",
          },
          { label: "Terminal ID", field: "terminalId" },
          { label: "Terminal Type", field: "terminalType" },
          { label: "Wallet ID", field: "walletId" },
          { label: "Card Number", field: "maskedPan" },
          { label: "STAN", field: "stan" },
          { label: "Merchant ID", field: "merchantId" },
          { label: "Amount", field: "amount" },
          { label: "Reference", field: "reference" },
          {
            label: "Processor",
            formatter: (row) => this.getProcessorName(row),
          },
          {
            label: "Response Code",
            formatter: (row) => this.getResponseCode(row),
          },
          {
            label: "Response Description",
            formatter: (row) => this.getResponseDesc(row),
          },
          {
            label: "Date",
            formatter: (row) =>
              row && row.createdAt
                ? new Date(row.createdAt).toLocaleString()
                : "—",
          },
          {
            label: "Sales Officer",
            formatter: (row) =>
              this.getSalesOfficerName(row && row.salesOfficerId) || "N/A",
          },
        ],
        PAY_WITH_TRANSFER: [
          { label: "S/N", type: "index" },
          { label: "Agent Name", field: "agentName" },
          {
            label: "Agent Category",
            formatter: (row) =>
              this.getMerchantName(row && row.customerCategory) || "N/A",
          },
          { label: "Recipient’s Wallet ID ", field: "walletId" },
          { label: "Recipient’s Account Number", field: "accountNumber" },
          { label: "Amount", field: "amount" },
          { label: "Sender’s Account Name", field: "originatorAccountName" },
          {
            label: "Sender’s Account Number",
            field: "originatorAccountNumber",
          },
          { label: "Sender’s Bank Name", field: "originatorBank" },
          { label: "Credit Status", field: "creditStatus" },
          { label: "Narration", field: "originatorNarration" },
          { label: "Reference", field: "reference" },
          { label: "Session ID", field: "sessionId" },
          {
            label: "Date/Time",
            formatter: (row) =>
              row && row.createdAt
                ? new Date(row.createdAt).toLocaleString()
                : "—",
          },

          {
            label: "Sales Officer",
            formatter: (row) => row.salesOfficer || "N/A",
            // formatter: (row) =>
            //   this.getSalesOfficerName(row && row.salesOfficer) || "N/A",
          },
        ],
        TRANSFER: [
          { label: "S/N", type: "index" },
          { label: "Transaction Type", field: "product" },
          { label: "Agent Name", field: "customerName" },
          {
            label: "Agent Category",
            formatter: (row) =>
              this.getMerchantName(row && row.customerCategory) || "N/A",
          },
          { label: "Wallet ID", field: "walletId" },
          { label: "Account Number", field: "account" },
          { label: "Account Name", field: "accountName" },
          { label: "Bank Name", field: "bankName" },
          { label: "Amount", field: "amount" },
          { label: "Transaction ID", field: "uniqueId" },
          { label: "Provider", field: "provider" },
          { label: "Provider Reference", field: "reference" },
          { label: "Status", field: "status" },
          {
            label: "Date",
            formatter: (row) =>
              row && row.createdAt
                ? new Date(row.createdAt).toLocaleString()
                : "—",
          },
          {
            label: "Sales Officer",
            formatter: (row) =>
              this.getSalesOfficerName(row && row.salesOfficerId) || "N/A",
          },
        ],
        AIRTIME: [
          { label: "S/N", type: "index" },
          { label: "Agent Name", field: "customerName" },

          {
            label: "Agent Category",
            formatter: (row) =>
              this.getMerchantName(row && row.customerCategory) || "N/A",
          },

          { label: "Wallet ID", field: "walletId" },
          { label: "Product(Network)", field: "product" },
          { label: "Phone Number", field: "account" },
          { label: "Amount", field: "amount" },
          { label: "Transaction ID", field: "uniqueId" },
          { label: "Provider Reference", field: "reference" },
          { label: "Provider", field: "provider" },
          { label: "Status", field: "status" },
          {
            label: "Date/Time",
            formatter: (row) =>
              row && row.createdAt
                ? new Date(row.createdAt).toLocaleString()
                : "—",
          },
          {
            label: "Sales Officer",
            formatter: (row) => row.salesOfficer || "N/A",
            // formatter: (row) =>
            //   this.getSalesOfficerName(row && row.salesOfficer) || "N/A",
          },
        ],
        DATA: [
          { label: "S/N", type: "index" },
          { label: "Agent Name", field: "customerName" },

          {
            label: "Agent Category",
            formatter: (row) =>
              this.getMerchantName(row && row.customerCategory) || "N/A",
          },

          { label: "Wallet ID", field: "walletId" },
          { label: "Product(Network)", field: "product" },
          { label: "Phone Number", field: "account" },
          { label: "Amount", field: "amount" },
          { label: "Transaction ID", field: "uniqueId" },
          { label: "Provider Reference", field: "reference" },
          { label: "Status", field: "status" },
          {
            label: "Date/Time",
            formatter: (row) =>
              row && row.createdAt
                ? new Date(row.createdAt).toLocaleString()
                : "—",
          },
          {
            label: "Sales Officer",
            formatter: (row) => row.salesOfficer || "N/A",
            // formatter: (row) =>
            //   this.getSalesOfficerName(row && row.salesOfficer) || "N/A",
          },
        ],
        ELECTRICITY: [
          { label: "S/N", type: "index" },
          { label: "Agent Name", field: "customerName" },

          {
            label: "Agent Category",
            formatter: (row) =>
              this.getMerchantName(row && row.customerCategory) || "N/A",
          },

          { label: "Wallet ID", field: "walletId" },
          { label: "Product(Discos)", field: "product" },
          { label: "Meter Number", field: "account" },
          { label: "Amount", field: "amount" },
          { label: "Transaction ID", field: "uniqueId" },
          { label: "Provider Reference", field: "reference" },
          { label: "Account Type", field: "accountType" },
          { label: "Status", field: "status" },
          {
            label: "Date/Time",
            formatter: (row) =>
              row && row.createdAt
                ? new Date(row.createdAt).toLocaleString()
                : "—",
          },
          {
            label: "Sales Officer",
            formatter: (row) =>
              this.getSalesOfficerName(row && row.salesOfficerId) || "N/A",
          },
        ],
        CABLE: [
          { label: "S/N", type: "index" },
          { label: "Agent Name", field: "customerName" },

          {
            label: "Agent Category",
            formatter: (row) =>
              this.getMerchantName(row && row.customerCategory) || "N/A",
          },

          { label: "Wallet ID", field: "walletId" },
          { label: "Product", field: "product" },
          { label: "Smart Card Number", field: "uniqueId" },
          { label: "Amount", field: "amount" },
          { label: "Transaction ID", field: "uniqueId" },
          { label: "Provider Reference", field: "reference" },
          { label: "Account Type", field: "accountType" },
          { label: "Status", field: "status" },
          {
            label: "Date/Time",
            formatter: (row) =>
              row && row.createdAt
                ? new Date(row.createdAt).toLocaleString()
                : "—",
          },
          {
            label: "Sales Officer",
            formatter: (row) =>
              this.getSalesOfficerName(row && row.salesOfficerId) || "N/A",
          },
        ],
      },
      pieChartData: {
        labels: [],
        counts: [],
        datasets: [
          {
            data: [],
            backgroundColor: [],
          },
        ],
      },
    };
  },

  computed: {
    activeSchema() {
      return this.tableSchemas[this.selectedType.key] || [];
    },

    failedTransactions() {
      const total =
        (this.totalTransactions && this.totalTransactions.count) || 0;
      const success =
        (this.successfulTransactions && this.successfulTransactions.count) || 0;
      console.log("Total:", this.totalTransactions);
      console.log("Success:", this.successfulTransactions);
      return total - success;
    },

    pieChartOptions() {
      if (!this.selectedType) return [];

      switch (this.selectedType.key) {
        case "PAY_WITH_TRANSFER":
          return [
            {
              label: "Provider",
              value: "provider",
            },
          ];

        case "AIRTIME":
          return [
            {
              label: "Provider",
              value: "provider",
            },
          ];
        case "DATA":
          return [
            {
              label: "Provider",
              value: "provider",
            },
          ];

        case "ELECTRICITY":
          return [
            {
              label: "Provider",
              value: "provider",
            },
          ];
        case "CABLE":
          return [
            {
              label: "Provider",
              value: "provider",
            },
          ];

        default: // withdrawal, etc.
          return [
            {
              label: "Terminal Type",
              value: "terminalType",
            },
            {
              label: "Provider",
              value: "provider",
            },
          ];
      }
    },
  },

  methods: {
    ...mapActions(["setNotification"]),

    safeValue(row, field) {
      if (!row || !field) return "—";
      const val = row[field];
      return val === undefined || val === null ? "—" : val;
    },

    async getTransactions() {
      this.tableLoading = true;
      this.analyticsTransactions = [];
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/analytics/transactions`,
          {
            startDate: this.startDate,
            endDate: this.endDate,
            type: this.selectedType && this.selectedType.key,
          },
        );

        const {
          failedTransactions,
          pendingTransactions,
          reversedTransactions,
          successfulTransactions,
          totalTransactions,
        } = res.data.summary;

        this.failedTransactions = failedTransactions;
        this.pendingTransactions = pendingTransactions;
        this.reversedTransactions = reversedTransactions;
        this.successfulTransactions = successfulTransactions;
        this.totalTransactions = totalTransactions;

        const {
          docs,
          hasNextPage,
          hasPrevPage,
          totalPages,
          prevPage,
          nextPage,
          totalDocs,
          page,
        } = res.data.data;

        this.analyticsTransactions = [...docs];
        console.log("Docs:", this.analyticsTransactions);
        this.hasPrevPage = hasPrevPage;
        this.hasNextPage = hasNextPage;
        this.totalPages = totalPages;
        this.prevPage = prevPage;
        this.nextPage = nextPage;
        this.totalDocs = totalDocs;
        this.page = page;

        // this.loading = false;
      } catch (err) {
        this.tableLoading = false;
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      } finally {
        this.tableLoading = false;
      }
    },

    getMerchantId(transaction) {
      return (
        (transaction &&
          transaction.terminalInformation &&
          transaction.terminalInformation.merchantId) ||
        "—"
      );
    },

    getProcessorName(transaction) {
      return (
        (transaction &&
          transaction.response &&
          transaction.response.processor_name) ||
        "—"
      );
    },

    getResponseCode(transaction) {
      return (
        (transaction &&
          transaction.response &&
          transaction.response.responseCode) ||
        "—"
      );
    },

    getResponseDesc(transaction) {
      return (
        (transaction &&
          transaction.response &&
          transaction.response.description) ||
        "—"
      );
    },

    getPercentageVol(value) {
      if (!this.totalTransactions || this.totalTransactions.count === 0)
        return "0%";
      return (
        ((value / this.totalTransactions.count) * 100).toFixed(1) +
        "% of Total Transactions"
      );
    },

    getPercentageValue(value) {
      if (!this.totalTransactions || this.totalTransactions.value === 0)
        return "0%";
      return (
        ((value / this.totalTransactions.value) * 100).toFixed(1) +
        "% of Total Transactions"
      );
    },

    async getSalesOfficers() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/user/get-all-users`,
        );
        this.allSalesOfficers = res.data.users;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    async getInstitution() {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/auth/get-institutions`,
        );
        this.allInstitutions = res.data.docs;
        console.log(this.allInstitutions);
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Institutions",
          });
        }
        console.log("error", err);
      }
    },

    getSalesOfficerName(id) {
      const officer = this.allSalesOfficers.find(
        (officer) => officer._id === id,
      );
      if (!officer) return "";

      return officer.lastName
        ? `${officer.firstName} ${officer.lastName}`
        : officer.firstName;
    },

    getInstitutionName(id) {
      const institution = this.allInstitutions.find(
        (institution) => institution._id === id,
      );
      if (!institution || id === null) return "";
      return institution ? institution.institutionName : "";
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },

    toggleBarDropdown() {
      this.isBarOpen = !this.isBarOpen;
    },

    togglePieDropdown() {
      this.isPieOpen = !this.isPieOpen;
    },

    async selectOption(option) {
      this.selectedType = { ...option };
      this.isOpen = false;
      await this.getTransactions();
      this.getBarChartData();
      this.getPieChartData();
      this.buildChart();
      this.buildPieChart();
    },

    async selectOptionBarType(option) {
      this.selectedBarType = option;
      this.isBarOpen = false;
      this.buildChart();
    },

    async selectOptionPieType(option) {
      this.selectedPieType = option;
      this.isPieOpen = false;
      this.getPieChartData();
      this.buildPieChart();
    },

    async refresh(mode) {
      try {
        this.tableLoading = true;
        if (mode === "filter" || mode === "refresh") {
          this.page = 1;
          this.currentPage = 1;
          this.buildChart();
        }
        let payload = {
          page: this.page,
          startDate: this.startDate,
          endDate: this.endDate,
          type: this.selectedType && this.selectedType.key,
          ...this.searchValues,
        };
        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
          case "download":
            payload = { ...payload, download: true };
            break;
          case "refresh":
            payload = { ...payload, page: 1 };
            this.currentPage = 1;
            this.selectedValue = "";
            break;
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/analytics/transactions`,
          payload,
        );
        if (mode === "download") {
          const rows = res.data.rows;

          const safeRows = rows.filter(
            (r) => r && typeof r === "object" && !Array.isArray(r),
          );

          if (!safeRows.length) {
            throw new Error("No valid rows to export");
          }

          const csvTran = convertArrayToCSV(safeRows);
          fileDownload(csvTran, "analytics_transactions.csv");
          return;
        } else {
          const {
            failedTransactions,
            pendingTransactions,
            reversedTransactions,
            successfulTransactions,
            totalTransactions,
          } = res.data.summary;

          this.failedTransactions = failedTransactions;
          this.pendingTransactions = pendingTransactions;
          this.reversedTransactions = reversedTransactions;
          this.successfulTransactions = successfulTransactions;
          this.totalTransactions = totalTransactions;

          const {
            docs,
            hasNextPage,
            hasPrevPage,
            totalPages,
            prevPage,
            nextPage,
            totalDocs,
            page,
          } = res.data.data;
          this.analyticsTransactions = docs;
          this.hasPrevPage = hasPrevPage;
          this.hasNextPage = hasNextPage;
          this.totalPages = totalPages;
          this.prevPage = prevPage;
          this.nextPage = nextPage;
          this.totalDocs = totalDocs;
          this.page = page;
        }
      } catch (error) {
        if (error.response && error.response.data) {
          const { message } = error.response.data;
          this.setNotification({ type: "danger", message });
        } else {
          this.setNotification({
            type: "danger",
            message: "Unable to Fetch Transactions",
          });
        }
      }
      this.tableLoading = false;
    },

    clearSearchFields() {
      this.searchValues = {
        agentName: "",
        agentCategory: "",
        terminalId: "",
        merchantId: "",
        reference: "",
      };
    },

    async getBarChartData() {
      this.loading = true;

      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/analytics/transactions/bar-chart?type=${this.selectedType.key}`,
        );

        this.groupByCustomerCategory = res.data.data.groupByCustomerCategory;
        this.groupByCustomerName = res.data.data.groupByCustomerName;
        this.groupByProduct = res.data.data.groupByProduct;
        this.groupBySalesOfficer = res.data.data.groupBySalesOfficer;
        this.groupByTerminalId = res.data.data.groupByTerminalId;
        this.groupByWalletId = res.data.data.groupByWalletId;

        this.loading = false;
      } catch (err) {
        this.loading = false;
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    buildChart() {
      let rawData = this[this.selectedBarType.key];
      if (!rawData) return;

      let categories = Object.entries(rawData).map(([label, obj]) => {
        return { label, count: Number(obj[this.selectedChartMetric] || 0) };
      });

      categories.sort((a, b) => {
        return this.sortOrder === "asc" ? a.count - b.count : b.count - a.count;
      });

      const labels = categories.map((c) => c.label);
      const series = [categories.map((c) => c.count)];

      const dynamicHeight = labels.length * 50;
      this.$refs.barChart.style.height = `${dynamicHeight}px`;

      new Chartist.Bar(
        this.$refs.barChart,
        {
          labels,
          series,
        },
        {
          seriesBarDistance: 15,
          reverseData: true,
          horizontalBars: true,
          axisY: {
            offset: 100,
          },
          axisX: {
            onlyInteger: this.selectedChartMetric === "volume",
          },
        },
      );
    },

    async getPieChartData() {
      this.loading = true;

      try {
        const resp = await axios.post(
          `${process.env.VUE_APP_API_URL}/analytics/transactions/pie-chart?type=${this.selectedType.key}`,
        );

        const responseData = resp.data.data;

        let dataset = [];

        if (Array.isArray(responseData)) {
          // PWT
          dataset = responseData;
        } else {
          // Withdrawal
          dataset = responseData[this.selectedPieType.value] || [];
        }

        console.log("Pie Chart Data:", dataset);

        if (!Array.isArray(dataset) || dataset.length === 0) {
          console.warn("⚠️ Empty dataset:", dataset);
          return;
        }

        const labels = dataset.map((item) => item._id || "Unknown");
        const series = dataset.map((item) =>
          Number(item[this.selectedMetric] || 0),
        );

        this.pieChartData = {
          labels,
          counts: series, // raw counts if you want
          datasets: [
            {
              data: series, // percentages or values
              backgroundColor: [
                "#75d7f0",
                "#1687a4",
                "#3cafcd",
                "#0d8faa",
                "#14a0c3",
                "#56c8e2",
                "#67b1c2",
                "#c0f5ff",
              ],
            },
          ],
        };

        this.buildPieChart(labels, series);
      } catch (err) {
        this.loading = false;
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    buildPieChart(labels, series) {
      if (!this.$refs.pieChart) return;

      this.$refs.pieChart.innerHTML = "";

      new Chartist.Pie(
        this.$refs.pieChart,
        { labels, series },
        { showLabel: true },
        { labelDirection: "explode" },
      );
    },

    selectMetric(key) {
      this.selectedMetric = key;
      this.getPieChartData();
      this.buildPieChart();
      this.loading = false;
    },
    selectChartMetric(key) {
      this.selectedChartMetric = key;
      this.getBarChartData();
      this.buildChart();
    },

    async getMerchants() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/merchant/get-all-merchants`,
        );
        const { merchants } = res.data;
        this.allMerchants = merchants;

        console.log("merchants:", this.allMerchants);
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    getMerchantName(id) {
      console.log("merchantId:", id);
      console.log("allMerchants:", this.allMerchants);
      const merchant = this.allMerchants.find(
        (merchant) => merchant._id === id,
      );
      return merchant ? merchant.merchantName : "";
    },
  },

  watch: {
    selectedValue() {
      this.clearSearchFields();
      this.refresh("filter");
    },

    loading(val) {
      console.log("Loading:", val);
    },

    selectedType() {
      const options = this.pieChartOptions;

      this.selectedPieType = options[0] || null;

      this.getPieChartData();
    },
  },

  async mounted() {
    this.getMerchants();
    this.getTransactions();
    this.getBarChartData();
    this.getPieChartData();
    this.buildChart();
    this.getSalesOfficers();
    this.getInstitution();
    this.loading = false;
  },
};
</script>

<style>
.card-stats-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  margin-bottom: 24px;
}

ul {
  list-style: none;
}

.dropdown {
  position: relative;
  width: 100%;
  /* margin-bottom: 20px; */
}

.dropdown-trigger {
  color: black;
  width: 100%;
  font-weight: 600;
  font-size: 16px;
  padding: 12px;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  max-width: 400px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu {
  position: absolute;
  width: 100%;
  max-width: 360px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 6px;
  margin-top: 6px;
  z-index: 100;
  padding: 8px 12px;
  color: black;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.menu li {
  cursor: pointer;
}
.menu li:hover,
.menu li.active {
  background: #f0f0f0;
}

.table-container {
  overflow-x: auto;
}

th {
  font-size: 12px !important;
  text-align: center;
}

.spinner-grow {
  position: fixed;
}

tbody {
  background: #fff !important;
}

.tms-dark {
  background-color: #333f48;
  color: #fff;
}

.search-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 24px;
}

.action_btns {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-items {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sort-by {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.pie-containers {
  background: white;
  padding: 16px;
  border-radius: 8px;
  width: 100%;
}

.pie-wrapper {
  /* display: flex;
  justify-content: center;
  align-items: center; */
  height: 400px; /* chart container height */
  width: 400px; /* chart container width */
}

.ct-chart {
  width: 100%;
  height: 100%;
}

.ct-chart .ct-label {
  font-size: 8px;
  fill: #333;
}

.metric-tabs {
  display: inline-flex;
  background: #f1f8ff;
  border-radius: 8px;
  padding: 4px 8px;
  gap: 4px;
}

.metric-tab {
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
  color: #9291a5;
}

.metric-tab:hover {
  background: #e6e9ef;
}

.metric-tab.active {
  background: #343a40;
  color: white;
  font-weight: 600;
}

.ct-series-a .ct-slice-pie {
  fill: #75d7f0 !important;
}
.ct-series-b .ct-slice-pie {
  fill: #1687a4 !important;
}
.ct-series-c .ct-slice-pie {
  fill: #3cafcd !important;
}

.ct-series-d .ct-slice-pie {
  fill: #0d8faa !important;
}

.ct-series-e .ct-slice-pie {
  fill: #14a0c3 !important;
}

.ct-series-f .ct-slice-pie {
  fill: #56c8e2 !important;
}

.ct-series-g .ct-slice-pie {
  fill: #67b1c2 !important;
}

.ct-series-h .ct-slice-pie {
  fill: #c0f5ff !important;
}
</style>
